/**
 * Created by Lauta on 9/2/2017.
 */
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  OnDestroy,
  OnInit
} from "@angular/core";
import { GlobalAppService } from "./core/commons/global-app.service";
import { Message } from "primeng/primeng";
import { Subscription } from "rxjs/Subscription";
declare var Ultima: any;

// noinspection TsLint
@Component({
  selector: "my-app",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"]
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent
  implements OnInit, DoCheck, AfterViewChecked, OnDestroy {
  msgs: Message[] = [];

  block = false;

  loadingSubscription: Subscription;
  messageSubscription: Subscription;

  public constructor(
    public appService: GlobalAppService //    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadingSubscription = this.appService.getLoading().subscribe(b => {
      this.block = b;
      // this.cd.markForCheck();
    });
    this.appService.getMsgs().subscribe(msg => {
      this.msgs = [];
      this.msgs.push(msg);
      // this.cd.markForCheck();
    });
  }

  ngDoCheck(): void {}

  ngAfterViewChecked(): void {}

  onCloseMessage(message: Message) {
    console.log(message);
    // this.cd.markForCheck();
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
    this.messageSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts